import React from 'react'
import { connect } from 'react-redux'
import { Button, Icon, Menu } from 'semantic-ui-react'

import { triggerBillingRun } from 'actions/billing'

const today = () => new Date().toISOString().slice(0, 10)

class TriggerBillingRunAction extends React.Component {
  state = { busy: false }

  handleClick = async () => {
    const runDate = window.prompt('Run billing as of (YYYY-MM-DD):', today())
    if (!runDate) return
    if (!window.confirm(`Trigger billing as of ${runDate}? Idempotent — already-billed periods are skipped.`)) return
    this.setState({ busy: true })
    try {
      const result = await this.props.trigger(runDate)
      window.alert(`Billing run started for ${result.run_date}.`)
    } catch (e) {
      window.alert(`Trigger failed: ${JSON.stringify(e)}`)
    }
    this.setState({ busy: false })
  }

  render () {
    return (
      <Menu.Item>
        <Button primary loading={this.state.busy} onClick={this.handleClick}>
          <Icon name="play"/> Trigger billing run
        </Button>
      </Menu.Item>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  trigger: (runDate) => dispatch(triggerBillingRun(runDate))
})

export default connect(null, mapDispatchToProps)(TriggerBillingRunAction)
